module.exports = __webpack_public_path__ + "img/sixpackcarrier93.ba07aed9.jpg";